import Helper from '../../../models/Helper';

const URI = '/users/:id/followed-courses';

/**
 * @desc Helper for courses following by users.
 */
class FollowedCoursesHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Get courses followed by given user.
   * @param {Number} userId Id of the user to get followed courses.
   * @return {Promise<Array<CourseWithUserInformation>>} The promise handling the request.
   * @example
   * const userId = 5678;
   * const response = await myClient.helpers.learningActivity.followedCourses.get(userId);
   */
  get(userId) {
    return super.get(userId);
  }
}

export default FollowedCoursesHelper;
